import {HiOutlineDotsCircleHorizontal} from "react-icons/hi";
import {BsCheckCircle} from "react-icons/bs";
import {TiDeleteOutline} from "react-icons/ti";
import {RiFolderHistoryFill} from "react-icons/ri";
import Tippy from "@tippyjs/react";
import {HiOutlineQuestionMarkCircle} from "react-icons/hi";


export const iconSwitch = (param) => {
    switch(param) {
        case 'Openstaand':
            return <Tippy content={param} placement="bottom"><span className="weekstaat-icon-align"><HiOutlineDotsCircleHorizontal fontSize={"24px"} /></span></Tippy>;
        case 'Goedgekeurd':
            return <Tippy content={param} placement="bottom"><span><BsCheckCircle color='#39A825' fontSize={"20px"}/></span></Tippy>;
        case 'Afgekeurd':
            return <Tippy content={param} placement="bottom"><span className="weekstaat-icon-align" style={{margin: -4}}><TiDeleteOutline color='#FB2E5F' fontSize={"26px"}/></span></Tippy>;
        default:
          return '--';
    }
}

export const resultIcon = (param) => {
    switch(param) {
        case 'Openstaand':
            return <Tippy content={param} placement="bottom"><span className="weekstaat-icon-align"><HiOutlineQuestionMarkCircle fontSize={"24px"} color="#ffa73f"/></span></Tippy>;
        case 'Goedgekeurd':
            return <Tippy content={param} placement="bottom"><span><BsCheckCircle color='#39A825' fontSize={"20px"}/></span></Tippy>;
        case 'Afgekeurd':
            return <Tippy content={param} placement="bottom"><span className="weekstaat-icon-align" style={{margin: -4}}><TiDeleteOutline color='#FB2E5F' fontSize={"26px"}/></span></Tippy>;
        default:
          return '--';
    }
}
// let str = "q|w|e";
// cosnt key = [1, 2, 3];
// let result = {q: 1, w: 2, e: 3}
export const parse = (sign, str, keys) => {
    const values = str.split(sign);
    let result = {};

    keys.forEach((value, index) => result[value] = values[index]);

    return result;
}
